import { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Box,
  IconButton,
} from '@mui/material'
import { MdClose } from 'react-icons/md'

const DEFAULT_START = '08:00'
const DEFAULT_END = '12:00'
const DEFAULT_TYPE = 'trabalho'

const formatHora = (v) => {
  const digits = v.replace(/\D/g, '').slice(0, 4)
  if (digits.length <= 2) return digits
  return `${digits.slice(0, 2)}:${digits.slice(2)}`
}

const horaValida = (t) => /^([01]\d|2[0-3]):[0-5]\d$/.test(t)

const getInitialState = () => ({
  start: DEFAULT_START,
  end: DEFAULT_END,
  type: DEFAULT_TYPE,
})

const ModalAdicionarFaixa = ({ open, onClose, onAdd }) => {
  const [start, setStart] = useState(DEFAULT_START)
  const [end, setEnd] = useState(DEFAULT_END)
  const [type, setType] = useState(DEFAULT_TYPE)

  const valido = horaValida(start) && horaValida(end) && start < end

  const handleSave = () => {
    if (!valido) return
    onAdd(start, end, type)
    handleClose()
  }

  const handleClose = () => {
    const initial = getInitialState()
    setStart(initial.start)
    setEnd(initial.end)
    setType(initial.type)
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        Adicionar Horário
        <IconButton size="small" onClick={handleClose}>
          <MdClose />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" alignItems="center" gap={2} sx={{ mt: 1 }}>
          <TextField
            label="Início"
            value={start}
            onChange={(e) => setStart(formatHora(e.target.value))}
            placeholder="HH:MM"
            InputLabelProps={{ shrink: true }}
            inputProps={{ maxLength: 5 }}
            size="small"
            sx={{ width: 130 }}
          />
          <Typography variant="body2">às</Typography>
          <TextField
            label="Fim"
            value={end}
            onChange={(e) => setEnd(formatHora(e.target.value))}
            placeholder="HH:MM"
            InputLabelProps={{ shrink: true }}
            inputProps={{ maxLength: 5 }}
            size="small"
            sx={{ width: 130 }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose}>Cancelar</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          disabled={!valido}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalAdicionarFaixa
